const MOBILE_SIDEBAR_MAX_WIDTH = 992;
const SIDEBAR_MODAL_IDS = [
    'send-blast-modal',
    'invite-previous-customers-modal',
    'cancel-event-modal',
];

export function initEventManageSidebar() {
    document.querySelectorAll('.event-manage-sidebar').forEach((sidebar) => {
        const toggle = sidebar.querySelector('[data-event-manage-sidebar-toggle]');
        const panel = sidebar.querySelector('[data-event-manage-sidebar-panel]');

        if (!toggle || !panel) {
            return;
        }

        const isMobile = () => window.innerWidth < MOBILE_SIDEBAR_MAX_WIDTH;

        const setOpen = (open) => {
            sidebar.classList.toggle('event-manage-sidebar--open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        const closeOnMobile = () => {
            if (isMobile()) {
                setOpen(false);
            }
        };

        const elevateModalOnMobile = (modal) => {
            closeOnMobile();

            if (!isMobile() || modal.parentElement === document.body) {
                return;
            }

            document.body.appendChild(modal);
        };

        const restoreModalToSidebar = (modal) => {
            if (!isMobile() || modal.parentElement !== document.body) {
                return;
            }

            sidebar.appendChild(modal);
        };

        toggle.addEventListener('click', () => {
            setOpen(!sidebar.classList.contains('event-manage-sidebar--open'));
        });

        panel.querySelectorAll('a[href]').forEach((link) => {
            link.addEventListener('click', () => {
                closeOnMobile();
            });
        });

        SIDEBAR_MODAL_IDS.forEach((modalId) => {
            sidebar.querySelectorAll(`#${modalId}`).forEach((modal) => {
                modal.addEventListener('show.bs.modal', () => elevateModalOnMobile(modal));
                modal.addEventListener('hidden.bs.modal', () => restoreModalToSidebar(modal));
            });
        });

        window.addEventListener('resize', () => {
            if (!isMobile()) {
                setOpen(false);
            }
        });
    });
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initEventManageSidebar);
    } else {
        initEventManageSidebar();
    }
}
